import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Clock } from 'lucide-react';

const EventTimingSection = ({ formData, setFormData, isExpanded, onToggle }) => {
  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="border-b pb-4">
      <button
        type="button"
        onClick={onToggle}
        className="flex items-center justify-between w-full text-left font-semibold text-[#1e3a5f] mb-3"
      >
        <span className="flex items-center gap-2">
          <Clock size={18} />
          Event Timing Details (BEO)
        </span>
        <span className="text-sm text-gray-500">{isExpanded ? '−' : '+'}</span>
      </button>
      
      {isExpanded && (
        <div className="grid grid-cols-3 gap-4 bg-gray-50 p-4 rounded-lg">
          <div>
            <Label>Event Start Time</Label>
            <Input
              type="time"
              data-testid="event-start-time-input"
              value={formData.eventStartTime}
              onChange={(e) => handleChange('eventStartTime', e.target.value)}
            />
          </div>
          <div>
            <Label>Breakfast</Label>
            <Input
              type="time"
              data-testid="breakfast-time-input"
              value={formData.breakfastTime || ''}
              onChange={(e) => handleChange('breakfastTime', e.target.value)}
            />
          </div>
          <div>
            <Label>Brunch</Label>
            <Input
              type="time"
              data-testid="brunch-time-input"
              value={formData.brunchTime || ''}
              onChange={(e) => handleChange('brunchTime', e.target.value)}
            />
          </div>
          <div>
            <Label>Lunch</Label>
            <Input
              type="time"
              data-testid="lunch-time-input"
              value={formData.lunchTime || ''}
              onChange={(e) => handleChange('lunchTime', e.target.value)}
            />
          </div>
          <div>
            <Label>Cocktail Hour</Label>
            <Input
              type="time"
              data-testid="cocktail-hour-input"
              value={formData.cocktailHourTime}
              onChange={(e) => handleChange('cocktailHourTime', e.target.value)}
            />
          </div>
          <div>
            <Label>Dinner Start</Label>
            <Input
              type="time"
              data-testid="dinner-start-input"
              value={formData.dinnerStartTime}
              onChange={(e) => handleChange('dinnerStartTime', e.target.value)}
            />
          </div>
          <div>
            <Label>Late Night Service</Label>
            <Input
              type="time"
              data-testid="late-night-input"
              value={formData.lateNightTime}
              onChange={(e) => handleChange('lateNightTime', e.target.value)}
            />
          </div>
          <div>
            <Label>Event End Time</Label>
            <Input
              type="time"
              data-testid="event-end-input"
              value={formData.eventEndTime}
              onChange={(e) => handleChange('eventEndTime', e.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EventTimingSection;
